import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { of } from 'rxjs';
import { UtilService } from '../services/util.service';

export const authenticationGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => { 
  const storageService = inject(StorageService);
  const utilService = inject(UtilService);
  const authorizationId = storageService.getAuthorizationId();

  if (authorizationId) {
    return of(true);
  } else {
    utilService.goToSignIn();
    return of(false);
  }
}
